<template>
  <button
    class="px-3 py-1 mr-2 mb-2"
    :style="selected ? 'background-color: #edf5ff' : 'background-color: #fff'"
    @click="$emit('select')"
  >
    {{ variant.option_label || variant.title }}
  </button>
</template>

<script>
export default {
  props: {
    variant: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Boolean,
    },
  },
};
</script>

<style scoped>
  button {
    border: solid 2px #070a3c;
    border-radius: 1vh;
  }
</style>
